export const JsError = Symbol("JsError");
export const Unknown = Symbol("Unknown");
export const CompositeError = Symbol("CompositeError");
export const Unauthenticated = Symbol("Unauthenticated");
export const Unauthorized = Symbol("Unauthorized");
export const ActionDenied = Symbol("ActionDenied");
export const NotFound = Symbol("NotFound");
export const Timeout = Symbol("Timeout");
export const InvalidOperation = Symbol("InvalidOperation");
export const InvalidArgument = Symbol("InvalidArgument");
export const InvalidState = Symbol("InvalidState");
export const InvariantViolation = Symbol("InvariantViolation");
export const HttpError = Symbol("HttpError");
export const PrismaError = Symbol("PrimaError");
export const ZodError = Symbol("ZodError");
export const ExpoPushTicketError = Symbol("ExpoError");
export const ExpoPushFailureError = Symbol("ExpoError");
export const LuxonError = Symbol("LuxonError");
export const FetchError = Symbol("FetchError");
//# sourceMappingURL=errorCode.js.map